import React from 'react';
import { Section } from '../ui/Section';
import { Clock, BookOpen, Leaf } from 'lucide-react';
export function HowItWorks() {
  const steps = [{
    icon: <BookOpen className="w-8 h-8 text-[#14B8A6]" data-id="element-111" />,
    title: '1. Entiende tu Cuerpo',
    description: 'Descubre los detonantes ocultos en tu rutina de oficina que están causando el 80% de tu inflamación.'
  }, {
    icon: <Clock className="w-8 h-8 text-[#14B8A6]" data-id="element-112" />,
    title: '2. Aplica el Método de 10 Min',
    description: 'Rutinas simples y rápidas que puedes hacer incluso sentada en tu escritorio para liberar gas y tensión.'
  }, {
    icon: <Leaf className="w-8 h-8 text-[#14B8A6]" data-id="element-113" />,
    title: '3. Disfruta la Ligereza',
    description: 'Vuelve a usar tus jeans favoritos sin miedo y termina el día laboral con la misma energía con la que empezaste.'
  }];
  return <Section id="how-it-works" background="cream" data-id="element-114">
      <div className="text-center mb-16" data-id="element-115">
        <h2 className="text-3xl md:text-4xl font-serif font-bold text-[#4A3B32] mb-4" data-id="element-116">
          Lo que encontrarás dentro
        </h2>
        <p className="text-[#5D5D5D] max-w-2xl mx-auto" data-id="element-117">
          Un sistema probado, diseñado específicamente para mujeres con poco
          tiempo y mucho estrés.
        </p>
      </div>

      <div className="grid md:grid-cols-3 gap-8 relative" data-id="element-118">
        {/* Connecting line for desktop */}
        <div className="hidden md:block absolute top-12 left-[16%] right-[16%] h-0.5 bg-[#5EEAD4]/30 -z-10" data-id="element-119"></div>

        {steps.map((step, index) => <div key={index} className="flex flex-col items-center text-center group" data-id="element-120">
            <div className="w-24 h-24 bg-white rounded-full flex items-center justify-center shadow-md mb-6 border-4 border-[#F0FDFA] group-hover:border-[#5EEAD4] transition-colors duration-300" data-id="element-121">
              {step.icon}
            </div>
            <h3 className="text-xl font-serif font-bold text-[#4A3B32] mb-3" data-id="element-122">
              {step.title}
            </h3>
            <p className="text-[#5D5D5D] leading-relaxed px-4" data-id="element-123">
              {step.description}
            </p>
          </div>)}
      </div>

      <div className="mt-16 bg-white p-8 rounded-2xl shadow-sm border border-[#5EEAD4]/20 flex flex-col md:flex-row items-center justify-between gap-8" data-id="element-124">
        <div className="flex-1" data-id="element-125">
          <h4 className="text-xl font-bold text-[#4A3B32] mb-2" data-id="element-126">
            ¿Por qué funciona?
          </h4>
          <p className="text-[#5D5D5D]" data-id="element-127">
            A diferencia de las dietas restrictivas que aumentan el estrés (y la
            inflamación), esta guía se enfoca en{' '}
            <span className="font-semibold text-[#14B8A6]" data-id="element-128">
              descompresión mecánica y digestiva
            </span>
            . Atacamos la causa raíz física, no solo los síntomas.
          </p>
        </div>
        <div className="flex-shrink-0 bg-[#CCFBF1] px-6 py-4 rounded-xl text-center" data-id="element-129">
          <span className="block text-3xl font-bold text-[#14B8A6]" data-id="element-130">100%</span>
          <span className="text-sm text-[#4A3B32] font-medium" data-id="element-131">Natural</span>
        </div>
      </div>
    </Section>;
}